/* Hamburger */
$(document).ready(function () {
  $('#menu-toggle .hamburger').click(function () {
    $(this).toggleClass('is-active');
    $('#main-nav').toggleClass('is-dropdown');
    $('html,body').toggleClass('no-scroll');
    const classList = $(this).attr('class').split(/\s+/);

    const dom1 = document.getElementById("mth-search");
    const dom2 = document.getElementById("mth-search-2");

    if(dom1 != null){
      if(classList.includes("is-active")){
        SearchBarHide_action({id:"mth-search"});
      }
      else{
        SearchBarShow_action({id:"mth-search"});
      }
    }

    if(dom2 != null){
      if(classList.includes("is-active")){
        SearchBarHide_action({id:"mth-search-2"});
      }
      else{
        SearchBarShow_action({id:"mth-search-2"});
      }
    }
    
  });
  if ($('.carousel-hero').length > 0) {
    $('.nav--main').addClass('is-carousel-hero');
    $('.logo .logo--dark').hide();
    $('.logo .logo--light').show();
  }
  
  /*Hide Agents from header menu for desktop view*/
  $('.nav--menu-item.dropdown--trigger').each(function() {
    var menuItem = $(this);
	if(menuItem.children('a').length > 0) {
	  var atext = menuItem.children('a')[0].text;
	  if(atext.includes('Agents')) {
		menuItem.addClass('hide-for-large');
	  }
	}	
  });
});

/* Nav Bar Scrolling */
var navScrolling = $(function () {
  /* Options */
  var nav = $('nav.nav--main');
  var logo = $('.logo--dark');
  var button = $('#button--search');
  var staticLogo = $('.logo .logo--dark');
  var scrollingLogo = $('.logo .logo--light');
  var scrollingClass = 'scrolling';
  var scrollThreshold = 1;
  var fadeOutTime = 175;
  var fadeInTime = 200;

  /* Logic */
  var resizeTimer;
  var heroBgIsWhite;
  var touchtime = 0;
  var scrolled = false;
  var isMobile = (/Mobi/.test(navigator.userAgent)) ? true : false;

  $(function () {
    checkScrolled();
  });
  $(document).on('scroll', function (e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      checkScrolled();
    }, 50);
  });
  $(window).on('resize', function (e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      checkScrolled();
      checkLogo();
    }, 150);
  });

  $('body').on('click', '.nav--menu-item.dropdown--trigger > a', function (e) {
    if (isMobile) {
      e.preventDefault();
      dropdownDoubleClick();
    }
  });

  function checkScrolled() {
    checkHeroBgColor();
    var scrollTop = $(document).scrollTop();
    var winWidth = $(document).width();
    if ((!scrolled && (scrollTop > scrollThreshold) && winWidth > 1023) ||
      (!scrolled && (scrollTop <= scrollThreshold) && winWidth > 1023 && heroBgIsWhite)) {
      // if no scrolling class AND not at top of screen OR background IS white
      setScrolled();
    } else if (scrolled && (scrollTop <= scrollThreshold) && winWidth > 1023 && !heroBgIsWhite) {
      // if scrolling class AND at top of screen AND hero background IS NOT white
      disableScrolled();
    }
  }

  function checkLogo() {
    /* Set the correct logo for the screen size */
    var scrollTop = $(document).scrollTop();
    var winWidth = $(document).width();
    if (winWidth < 1024 && $('.carousel-hero').length == 0) {
      staticLogo.fadeOut(fadeOutTime, function () {
        scrollingLogo.fadeIn(fadeInTime);
      });

      if ($('#main-nav').hasClass('is-dropdown')) {
        $('html,body').addClass('no-scroll');
      } else {
        $('html,body').removeClass('no-scroll');
      }
    } else {
      $('html,body').removeClass('no-scroll');
      if (scrollTop <= scrollThreshold && !heroBgIsWhite && $('.carousel-hero').length == 0) {
        scrollingLogo.fadeOut(fadeOutTime, function () {
          staticLogo.fadeIn(fadeInTime);
        });
      } else if (scrolled && scrollTop <= scrollThreshold && !heroBgIsWhite) {
        staticLogo.fadeOut(fadeOutTime, function () {
          scrollingLogo.fadeIn(fadeInTime);
        });
      }
    }
  }

  function checkHeroBgColor() {
    /* Check if the hero background is white or has a bg image */
    if (
      !$('.hero-dummy').length &&
      ($('nav.nav--main + *').length > 0 &&
        $('nav.nav--main + *').css("background-image") !== 'none' ||
        $('.hero > .row *').length > 0 ||
        $('.carousel-hero > *').length > 0 &&
        $('.hero > .row').css("background-image") !== 'none')
    ) {
      heroBgIsWhite = false;
    } else {
      heroBgIsWhite = true;

      if ($('.breadcrumbs-container').length && !$('#loginBuyer').length && !$('#resetPasswordBuyer').length) {
        $('.breadcrumbs-container').addClass('inverse');
      }
    }
  }

  function setScrolled() {
    scrolled = true;
    staticLogo.fadeOut(fadeOutTime, function () {
      scrollingLogo.fadeIn(fadeInTime);
    });
    nav.fadeOut(fadeOutTime, function () {
      nav.toggleClass(scrollingClass);
      button.swapClass('button--white', 'button--blue');
      nav.fadeIn(fadeInTime);
    });
  }

  function disableScrolled() {
    scrolled = false;
    scrollingLogo.fadeOut(fadeOutTime, function () {
      staticLogo.fadeIn(fadeInTime);
    });
    nav.fadeOut(fadeOutTime, function () {
      nav.toggleClass(scrollingClass);
      button.swapClass('button--blue', 'button--white');
      nav.fadeIn(fadeInTime);
    });
  }

  function dropdownDoubleClick() {
    if (touchtime == 0) {
      //set first click
      touchtime = new Date().getTime();
    } else {
      //compare first click to this click and see if they occurred within double click threshold
      if (((new Date().getTime()) - touchtime) < 800) {
        //double click occurred
        window.location.href = $(this).attr('href');
        // touchtime = 0;
      } else {
        //not a double click so set as a new first click
        touchtime = new Date().getTime();
      }
    }
  }
});
